import { Controller } from '@hotwired/stimulus'
/** Specialized controller for the referral wizard's referral step.
The direct to psychiatry has a few special behaviors that need to be handled here.
High level, when a user selects direct to psychiatry, it will require an outside therapist attestation.
It will also disable all other services. **/
export default class extends Controller {
  static targets = [
    'psychiatryCheckbox',
    'otherService',
    'attestationContainer',
    'attestationCheckbox',
  ]

  connect() {
    this.update()
  }

  toggle() {
    this.update()
  }

  update() {
    const psychSelected = this.hasPsychiatryCheckboxTarget && this.psychiatryCheckboxTarget.checked

    // Show/hide attestation and toggle required attribute
    if (this.hasAttestationContainerTarget) {
      this.attestationContainerTarget.classList.toggle('hidden', !psychSelected)
    }
    if (this.hasAttestationCheckboxTarget) {
      if (psychSelected) {
        this.attestationCheckboxTarget.setAttribute('required', 'required')
      } else {
        this.attestationCheckboxTarget.removeAttribute('required')
        // Also uncheck if psychiatry is not selected
        this.attestationCheckboxTarget.checked = false
      }
    }

    // Disable/enable other services
    if (this.hasOtherServiceTarget) {
      this.otherServiceTargets.forEach((el) => {
        if (psychSelected) {
          el.checked = false
          el.setAttribute('disabled', 'disabled')
          el.classList.add('opacity-50', 'cursor-not-allowed', 'pointer-events-none')
          const wrapper =
            el.closest('.form-field-inline') ||
            el.closest('[data-test-id="form-field-inline"]') ||
            el.closest('label') ||
            document.querySelector(`label[for="${el.id}"]`)
          if (wrapper)
            wrapper.classList.add('cursor-not-allowed', 'pointer-events-none', 'text-charcoal-50')
        } else {
          el.removeAttribute('disabled')
          el.classList.remove('opacity-50', 'cursor-not-allowed', 'pointer-events-none')
          const wrapper =
            el.closest('.form-field-inline') ||
            el.closest('[data-test-id="form-field-inline"]') ||
            el.closest('label') ||
            document.querySelector(`label[for="${el.id}"]`)
          if (wrapper)
            wrapper.classList.remove(
              'cursor-not-allowed',
              'pointer-events-none',
              'text-charcoal-50'
            )
        }
      })
    }
  }
}
